import { useContext } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Card } from 'shared/components';
import { PageTitle } from 'shared/components/Fonts';
import { FilterTransfersForm } from 'core/cuenta/components/FilterTransfersForm/FilterTransfersForm';
import { TransfersTableWithPagination } from 'core/cuenta/components/TransfersTableWithPagination/TransfersTableWithPagination';
import { TransfersContext } from 'core/cuenta/contexts/TransfersContext';

export const TransfersPage = () => {
  const { searchParams, transferencias, isLoading, searchTransfers } = useContext(TransfersContext);

  return (
    <Container fluid>
      <Row className="mb-3">
        <PageTitle>Historial de transferencias</PageTitle>
      </Row>
      <Row className="mb-4">
        <Col>
          <Card>
            <Card.Title>Filtros</Card.Title>
            <Card.Body>
              <FilterTransfersForm onSubmit={searchTransfers} />
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col>
          <Card>
            <Card.Title>Transferencias</Card.Title>
            <Card.Body>
              <TransfersTableWithPagination
                loadingState={isLoading}
                searchParams={searchParams}
                transferencias={transferencias}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
